<metutors-modal [showModal]="showModal" (closeModal)="closeModal.emit()" [size]="'medium'"
                [template]="template" [panelClass]="'filter-blur-10'"
                [heading]="'EMAIL_VERIFICATION'"
                [subHeading]="'PLEASE_CHECK_OTP_CODE_SENT_EMAIL'">
  <ng-template #template>
    <metutors-signup-email-verification [showHint]="false" [email]="email!"
                                        (resendEmail)="resendEmail.emit()"
                                        [loading]="loading"
                                        [resendLoading]="resendLoading"
                                        (submitForm)="submitForm.emit($event)">
    </metutors-signup-email-verification>
  </ng-template>
</metutors-modal>